<template>
    <div :style="{ backgroundColor: bgColor }" class="stat-card">
        <div class="stat-header">
            <span class="stat-title">{{ title }}</span>
        </div>
        <div class="stat-number" :style="{ fontSize: fontSize }">{{ data }}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        data: {
            type: [String, Number],
            required: true
        },
        bgColor: {
            type: String,
            required: false,
            default: '#2d2e48'
        },
        fontSize: {
            type: String,
            required: false,
            default: '48px'  // Default font size if none provided
        }
    }
};
</script>

<style scoped>
.stat-card {
    padding: 20px;
    border-radius: 12px;
    text-align: center;
    color: white;
    font-family: 'Arial', sans-serif;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease-in-out;
}

.stat-card:hover {
    transform: translateY(-5px);
}

.stat-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
}

.stat-title {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    color: white;
}

.stat-number {
    font-weight: bold;
    color: white;
}
</style>